import { PencilIcon, TrashIcon } from '@heroicons/react/solid';
import React from 'react';

const PlantAreaButtons = (props) => {
  return (
    <>
      <div className="flex mt-3">
        <button
          onClick={() => props.setEditArea(props.area)}
          className="text-gray-500 hover:text-gray-700 mr-2"
        >
          <PencilIcon className="w-5 h-5" />
        </button>
        <button
          onClick={() => props.deleteAreaAndPlants(props.area.id)}
          className="text-red-500 hover:text-red-700"
        >
          <TrashIcon className="w-5 h-5" />
        </button>
      </div>
    </>
  );
};

export default PlantAreaButtons;
